import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "project-info"
}
const _hoisted_2 = { class: "project-info__header" }
const _hoisted_3 = { class: "project-info__header-left" }
const _hoisted_4 = { class: "project-info__field" }
const _hoisted_5 = { class: "project-info__field-name" }
const _hoisted_6 = { class: "project-info__field-value" }
const _hoisted_7 = { class: "project-info__field" }
const _hoisted_8 = { class: "project-info__field-name" }
const _hoisted_9 = { class: "project-info__field-value" }
const _hoisted_10 = {
  key: 0,
  class: "project-info__field-value"
}
const _hoisted_11 = { class: "project-info__field" }
const _hoisted_12 = { class: "project-info__field-name" }
const _hoisted_13 = { class: "project-info__field-value" }
const _hoisted_14 = {
  key: 0,
  class: "project-info__field-value"
}
const _hoisted_15 = {
  key: 0,
  class: "project-info__field"
}
const _hoisted_16 = { class: "project-info__field-name" }
const _hoisted_17 = { class: "project-info__field-value" }
const _hoisted_18 = { class: "project-info__header-right" }
const _hoisted_19 = { class: "project-info__records" }
const _hoisted_20 = {
  key: 0,
  class: "project-info__field project-info__field--col"
}
const _hoisted_21 = { class: "project-info__field-name" }
const _hoisted_22 = { class: "project-info__field-value-col-time" }
const _hoisted_23 = { class: "project-info__field-value-col-action" }
const _hoisted_24 = {
  key: 1,
  class: "project-info__field project-info__field--col"
}
const _hoisted_25 = { class: "project-info__field-name" }
const _hoisted_26 = { class: "project-info__field-value-col-time" }
const _hoisted_27 = { class: "project-info__field-value-col-action" }
const _hoisted_28 = {
  key: 2,
  class: "project-info__field project-info__field--col"
}
const _hoisted_29 = { class: "project-info__field-name" }
const _hoisted_30 = { class: "project-info__field-value-col-time" }
const _hoisted_31 = { class: "project-info__field-value-col-action" }
const _hoisted_32 = {
  key: 3,
  class: "project-info__field project-info__field--col"
}
const _hoisted_33 = { class: "project-info__field-name" }
const _hoisted_34 = { class: "project-info__field-value-col-time" }
const _hoisted_35 = { class: "project-info__field-value-col-action" }
const _hoisted_36 = { class: "project-info__field-value-col-person" }

import { computed, ref, watch } from "vue";
import { useModalEscape } from "@/composables/useModalEscape";
import { i18n } from "@/i18n";

import { useRoute } from "vue-router";
import moment from "moment";
import BaseModal from "@/components/common/modal/BaseModal.vue";
import AppTabsOld from "@/components/ui-kit/tabs/AppTabsOld.vue";
import AppLists from "@/components/ui-kit/lists/AppLists.vue";
import { ProjectApi } from "@/ api/ProjectApi";
import type { ProjectInfoFull } from "@/models/interfaces/project/project-models";
import { CommonEntityRecord } from "@/models/interfaces/common";
import { projectPageStore } from "@/store/project-page";
// import ProjectAccessRulesTab from "../permitions/ProjectAccessRulesTab.vue";
import MainPermitionsTab from "@/components/permitions/MainPermitionsTab.vue";
import { EntityRulesContainer } from "@/models/interfaces/access/entity-rules";
import { workerStore } from "@/store/worker";
import { AccessApi } from "@/ api/AccessApi";

const PROJECT_SEGMENT = 0;


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectInfoModal',
  setup(__props, { expose: __expose }) {

const t = (key: string): string => String(i18n.global.t(key));
const route = useRoute();
const projectPage = projectPageStore();
const worker = workerStore();

// const tabs = ref([
// 	{ id: 0, title: "Информация о клиенте", slotName: "info" },
// ]);

const tabs = computed(() =>
  projectPage.project?.RuleAccess == 1
    ? [
        { id: 0, title: t("project_info_title"), slotName: "info" },
        { id: 1, title: t("file_access_rights"), slotName: "rules" },
      ]
    : [
        { id: 0, title: t("project_info_title"), slotName: "info" },
      ]
)

// const tabs = [
//   { id: 0, title: "Информация о проекте", slotName: "info" },
//   { id: 1, title: "Права доступа", slotName: "rules" },
// ];

const $modal = ref<typeof BaseModal | null>(null);
const $lists = ref<InstanceType<typeof AppLists> | null>(null);
const $tabs = ref<InstanceType<typeof AppTabsOld> | null>(null);
const $content = computed<HTMLElement | null>(() => ($tabs.value?.$el as HTMLElement | null) ?? null);

const { activate: activateEsc, deactivate: deactivateEsc } = useModalEscape({
  content: $content,
  close: () => $modal.value?.onClose()
});

const rulesContainer = ref<EntityRulesContainer | null>(null);
const canEditRules = computed(
  () =>
    !!worker.workerProfile?.IsAdmin || projectPage.project?.RuleAccess === 1,
);

const activeTab = ref<number>(0);
const isLoading = ref(false);
const projectInfo = ref<ProjectInfoFull | null>(null);
const projectIdRef = ref<number>(0);
const tags = ref<CommonEntityRecord[]>([]);

const formatDate = (date: string | undefined | null) => {
  if (!date) return "";
  return moment(date).format("HH:mm DD.MM.YYYY");
};

watch(activeTab, () => {
  $lists.value?.close();
});

const onOpen = async (projectId: number, projectTags: CommonEntityRecord[] = []) => {
  try {
    projectIdRef.value = projectId;
    // clientIdRef.value = projectId;
    tags.value = projectTags;
    isLoading.value = true;
    activeTab.value = 0;
    projectInfo.value = null;
    $modal.value?.onOpen();
    activateEsc();

    projectInfo.value = await ProjectApi.getProjectInfo(projectId);
    await refreshRules();
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};

const onClose = () => {
	$modal.value?.onClose();
}

// watch(projectPage.project?.RuleAccess,() => { if(projectPage.project?.RuleAccess ==1) tabs.value = [
//   { id: 0, title: "Информация о проекте", slotName: "info" },
//   { id: 1, title: "Права доступа", slotName: "rules" },
// ];})

__expose({ onOpen });

const refreshRules = async () => {
  try {
    const rulesGiver = await AccessApi.getProjectAccessRules(projectIdRef.value);
    rulesContainer.value = rulesGiver?.Container ?? null;
  } catch (e) {
    console.error(e);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(BaseModal, {
    ref_key: "$modal",
    ref: $modal,
    "close-by-click-outside": "",
    "fullscreen-on-mobile": "",
    loading: isLoading.value,
    width: "900px",
    height: "800px",
    onOnClose: _unref(deactivateEsc)
  }, {
    default: _withCtx(() => [
      _createVNode(AppTabsOld, {
        ref_key: "$tabs",
        ref: $tabs,
        tabs: tabs.value,
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeTab).value = $event))
      }, {
        info: _withCtx(() => [
          (!isLoading.value && projectInfo.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('project_label')) + ": ", 1),
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(projectPage).project?.Name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('created_label')) + ": ", 1),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(formatDate(projectInfo.value.CreateTime)), 1),
                      (projectInfo.value.Creator?.Name)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, " [" + _toDisplayString(projectInfo.value.Creator.Name) + "]", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('last_edit_label')) + ": ", 1),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(formatDate(projectInfo.value.ChangeTime)), 1),
                      (projectInfo.value.Changer?.Name)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, " [" + _toDisplayString(projectInfo.value.Changer.Name) + "]", 1))
                        : _createCommentVNode("", true)
                    ]),
                    (tags.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('tags_upcase')) + ": ", 1),
                          _createElementVNode("span", _hoisted_17, _toDisplayString(tags.value.map((t) => `#${t.Name}`).join(", ")), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(AppLists, {
                      ref_key: "$lists",
                      ref: $lists,
                      modelValue: projectInfo.value.AnalyticsLists,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((projectInfo.value.AnalyticsLists) = $event)),
                      segment: PROJECT_SEGMENT,
                      "element-id": projectIdRef.value
                    }, null, 8, ["modelValue", "element-id"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  (projectInfo.value.StageChangeRecords?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('stage_changes')) + ":", 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectInfo.value.StageChangeRecords, (r, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `s-${idx}`,
                            class: "project-info__field-value-col"
                          }, [
                            _createElementVNode("span", _hoisted_22, _toDisplayString(formatDate(r.Date)) + " ", 1),
                            _createElementVNode("span", _hoisted_23, " [" + _toDisplayString(r.Creator?.Name) + "] " + _toDisplayString(_ctx.$t('stage_moved_to', { name: r.StageName })), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (projectInfo.value.WorkerAttachmentLogs?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('users_and_roles_label')) + ":", 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectInfo.value.WorkerAttachmentLogs, (log, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `w-${idx}`,
                            class: "project-info__field-value-col"
                          }, [
                            _createElementVNode("span", _hoisted_26, _toDisplayString(formatDate(log.CreatedAt)) + " ", 1),
                            _createElementVNode("span", _hoisted_27, _toDisplayString(log.Message), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (projectInfo.value.ClientChangeRecords?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('clients_and_roles_label')) + ":", 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectInfo.value.ClientChangeRecords, (r, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `c-${idx}`,
                            class: "project-info__field-value-col"
                          }, [
                            _createElementVNode("span", _hoisted_30, _toDisplayString(formatDate(r.RecordDate)) + " ", 1),
                            _createElementVNode("span", _hoisted_31, " [" + _toDisplayString(r.Author?.Name) + "] " + _toDisplayString(_ctx.$t(r.RecordType === 0 ? 'record_added' : 'record_removed')) + "  ", 1),
                            (r.Object)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  class: "project-info__field-value-col-link",
                                  to: {
                    query: {
                      page: 'client',
                      id: r.Object.Id,
                    },
                  }
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(r.Object.Name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (projectInfo.value.PersonChangeRecords?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('contacts_label')) + ":", 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectInfo.value.PersonChangeRecords, (r, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `p-${idx}`,
                            class: "project-info__field-value-col"
                          }, [
                            _createElementVNode("span", _hoisted_34, _toDisplayString(formatDate(r.RecordDate)) + " ", 1),
                            _createElementVNode("span", _hoisted_35, " [" + _toDisplayString(r.Author?.Name) + "] " + _toDisplayString(_ctx.$t(r.RecordType === 0 ? 'record_added' : 'record_removed')) + "  ", 1),
                            _createElementVNode("span", _hoisted_36, _toDisplayString(r.Object?.Name), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        rules: _withCtx(() => [
          _createVNode(MainPermitionsTab, {
            container: rulesContainer.value,
            "entity-id": projectIdRef.value,
            "can-edit": canEditRules.value,
            onSave: onClose,
            onRefresh: refreshRules,
            onCancel: onClose,
            type: "project"
          }, null, 8, ["container", "entity-id", "can-edit"])
        ]),
        _: 1
      }, 8, ["tabs", "modelValue"])
    ]),
    _: 1
  }, 8, ["loading", "onOnClose"]))
}
}

})